/** @jsxRuntime classic */
/** @jsx jsx */
import {
  AuthRestrict,
  SharedLayout,
  SharedLayoutChildProps,
  SubjectBanner,
  SubjectPageInner,
  UpgradeNudge,
  useSubjectSlug,
  useSubscriptionInfo,
} from "@app/components";
import { useSharedQuery, useSubjectBySlugQuery } from "@app/graphql";
import { jsx } from "@emotion/react";
import { NextPage } from "next";
import { useRouter } from "next/router";

import { LibraryStyleArtifact } from "../../../..";

const SubjectPage: NextPage = () => {
  const slug = useSubjectSlug();
  const query = useSharedQuery();
  const router = useRouter();
  const subjectQuery = useSubjectBySlugQuery({ variables: { slug } });
  const subject = subjectQuery?.data?.subjectBySlug;

  const { isTrialEnded, isSubscriptionPastDue, isAdmin } = useSubscriptionInfo();

  return (
    <div>
      <LibraryStyleArtifact />
      <SharedLayout title="" query={query} forbidWhen={AuthRestrict.NEVER}>
        {({ currentUser }: SharedLayoutChildProps) => {
          return (
            <div>
              <SubjectBanner
                name={subject?.name || slug}
                categoryName={subject?.category?.name || "Category"}
              ></SubjectBanner>
              <UpgradeNudge />

              <div css={{ filter: (isTrialEnded || isSubscriptionPastDue) && !isAdmin ? "grayscale(1)" : "none" }}>
                <SubjectPageInner
                  currentUser={currentUser}
                  subjectQuery={subjectQuery}
                  onRhymequizPreviewClick={(slug: string) => router.push(`/rhymequiz/${slug}`)}
                ></SubjectPageInner>
              </div>
            </div>
          );
        }}
      </SharedLayout>
    </div>
  );
};

export default SubjectPage;
